module.exports = __webpack_public_path__ + "img/move_reposnse.043697ed.png";